<script>
    import { createEventDispatcher, afterUpdate } from 'svelte';

    const dispatch = createEventDispatcher();

    import {fly,fade } from 'svelte/transition'
    import {cubicOut} from 'svelte/easing'
    import Switch from './Switch.svelte'
    export let isOpen;
    export let openShareModal;
    export let switchValue;
    export let toggleTheme;
    export let openCalendarModal;

    let focusedEventListener;

    function closeHamburger() {
        isOpen = false;
        dispatch('closeHamburger', { isOpen });
    }

    function listenMenuItem(ev){
        if(ev.key === 'Enter' || ev.key === ' '){
            ev.srcElement.click()
        }
    }
    function focusMenuItem(el){
        focusedEventListener = function(ev){listenMenuItem(ev)}
        window.addEventListener('keyup',focusedEventListener)
    }
    function blurMenuItem(el){
        window.removeEventListener('keyup',focusedEventListener)
    }

    afterUpdate(() => {
        if(isOpen){
            document.getElementById('darkmodeswitch').focus();
        }
    })

</script>

{#if isOpen}
    <div id="hamburgerbackground" on:click={closeHamburger} transition:fade></div>
    <div id="hamburgermenu" transition:fly="{{ x: -200, duration: 500, easing: cubicOut}}">
        <div id="headingrow">
            <div><img id="settingshead" src="./images/settings.png" alt="Settings" /></div>
            <div on:click={closeHamburger}>
                <svg viewBox="0 0 25 25" width="25" height="25">
                    <line x1="0" y1="0" x2="25" y2="25" style="stroke-width:3" />
                    <line x1="0" y1="25" x2="25" y2="0" style="stroke-width:3" />
                </svg>
            </div>
        </div>
        <ul>
            <li>
                <span class="left">Dark Mode</span>
                <span class="right">
                    <Switch value={switchValue} label="dark mode" fontSize={12} onChange={toggleTheme} focusableElementID="darkmodeswitch"/>
                </span>
            </li>
            <!--
                <li>
                    <span class="left">Questions?</span>
                    <span class="right"><a href="">FAQ</a></span>
                </li>
                <li>
                    <span class="left">Feedback / Puzzle submissions?</span>
                    <span class="right"><a href="mailto:">Email</a></span>
                </li>
            -->
            <li tabindex="0" on:click={openShareModal} on:focus={focusMenuItem} on:blur={blurMenuItem}>
                <span class="left">Stats</span>
                <span class="right">
                    <svg viewBox="0 0 40 30" width="40" height="30">
                        <rect y="18" width="5" height="12"></rect>
                        <rect x="10" y="10" width="5" height="20"></rect>
                        <rect x="20" y="16" width="5" height="14"></rect>
                        <rect x="30" y="6" width="5" height="24"></rect>    
                    </svg>
                </span>
            </li>
            <li tabindex="0" on:click={openCalendarModal} on:focus={focusMenuItem} on:blur={blurMenuItem}>
                <span class="left">Archive</span>
                <span class="right">
                    <svg width="40" height="40" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.5 10.5V19.5H20.5V10.5M4.5 10.5V5.5H20.5V10.5M4.5 10.5H12.5H20.5M20.5 13.5H16.5M16.5 13.5H12.5M16.5 13.5V10.5M16.5 13.5V16.5M12.5 13.5H8.5M12.5 13.5V16.5M12.5 13.5V10.5M8.5 13.5H4.5M8.5 13.5V10.5M8.5 13.5V16.5M20.5 16.5H16.5M16.5 16.5H12.5M16.5 16.5V19.5M12.5 16.5H8.5M12.5 16.5V19.5M8.5 16.5H4.5M8.5 16.5V19.5M17.5 8V3M7.5 8V3" stroke="var(--bg-color)"/>
                    </svg>    
                </span>
            </li>
            <li tabindex="0" on:click={()=>document.getElementById('instructionlink').click()} on:focus={focusMenuItem} on:blur={blurMenuItem}>
                <a id="instructionlink" href="https://www.pillboxgames.com/ampersandi" target="_blank" tabindex="-1">
                    <span class="left">Instructions</span>
                    <span class="right">
                        <svg class="outline-only" viewBox="0 0 25 25" width="40" height="30">
                            <path d="M 18 14
                                v 6
                                a 2 2 0 0 1 -2 2
                                H 6
                                a 2 2 0 0 1 -2 -2
                                V 10
                                a 2 2 0 0 1 2 -2
                                H 12"></path>
                            <line x1="12" y1="14" x2="20" y2="6"></line>
                            <polyline points="16 5.5, 20 5.5, 20 9.5"></polyline>
                        </svg>
                    </span>
                </a>
            </li>
            <li tabindex="0" on:click={()=>document.getElementById('submissionlink').click()} on:focus={focusMenuItem} on:blur={blurMenuItem}>
                <a id="submissionlink" href="https://www.pillboxgames.com/ampersandi-submission" target="_blank" tabindex="-1">
                    <span class="left">Submit a Puzzle</span>
                    <span class="right">
                        <svg class="outline-only" viewBox="0 0 25 25" width="40" height="30">
                            <path d="M 18 14
                                v 6
                                a 2 2 0 0 1 -2 2
                                H 6
                                a 2 2 0 0 1 -2 -2
                                V 10
                                a 2 2 0 0 1 2 -2
                                H 12"></path>
                            <line x1="12" y1="14" x2="20" y2="6"></line>
                            <polyline points="16 5.5, 20 5.5, 20 9.5"></polyline>
                        </svg>
                    </span>
                </a>
            </li>
            
        </ul>
        <div class="remainder">
            <p class="explain explain1">
                An ampersandi (am-pər-sand-ee) is a riddle form invented in 2008 by 
                Jade Shames and later resurrected and perfected by Pillbox Games. 
                Illustrations by Ben Bronstein. Engineering and development by Nathaniel Granor.
            </p> 
            <p class="explain explain2">
                Pillbox Games is based in Brooklyn, NY. We specialize in games for the strangely 
                curious and the curiously strange.
            </p>
    
            <a class="pblogo" href="https://www.pillboxgames.com/"><img src="images/PillBoxLogoBlackWT.webp" alt="Pillbox Games logo" /></a>
            <p class="copyright">©2022 Pillbox Games LLC</p>
        </div>
    </div>
{/if}


<style>
#hamburgerbackground {
    position:fixed;
    width:100%;
    height:100%;
    top:70px;
    background-color: var(--fg-color);
    opacity: 0.6;
    z-index:5;
    border-top: 2px solid var(--fg-color);
}

#hamburgermenu {
    width: 85%;
    max-width: 400px;
    height: 100%;
    position: fixed;
    display: flex;
    top:72px;
    left:0px;
    background:var(--bg-color);
    color:var(--fg-color);
    flex-direction: column;
    justify-content:left;
    z-index: 6;
}
#headingrow{
    display:flex;
    justify-content: center;
    padding-top:15px;
    padding-bottom:15px;
    flex-direction: row;
    align-items: center;
}
#headingrow img{
    width:80px;
}
#headingrow div:last-child {
  position: absolute;
  top: 15px;
  right: 15px;
}
#headingrow svg{
    stroke:var(--fg-color);
    cursor: pointer;
}
#headingrow svg:hover,#headingrow svg:focus{
    stroke:var(--accent);
}
#hamburgermenu ul{
    padding:0px;
    margin:0px;
}
#hamburgermenu li{
    height:42px;
    padding-left: 20px;
    cursor: pointer;
    border-bottom: 1px solid var(--fg-color);
    display:flex;
    align-items: center;
}
#hamburgermenu li a{
    display:flex;
    align-items: center;
    width:100%;
}
#hamburgermenu li a:hover, #hamburgermenu li a:focus{
    text-decoration: none;
}
#hamburgermenu li span{
    display:inline-block;
}
#hamburgermenu li span.left{
    width:80%;
}
#hamburgermenu li span{
    color:var(--fg-color);
}
#hamburgermenu li:hover span, #hamburgermenu li:focus span, #hamburgermenu li:focus-within span{
    color:var(--accent);
}
#hamburgermenu svg{
    fill:var(--fg-color);
}
#hamburgermenu li:hover svg, #hamburgermenu li:focus svg{
    fill: var(--accent);
}
#hamburgermenu svg.outline-only{
    stroke:var(--fg-color);
    fill: transparent;
}
#hamburgermenu li:hover svg.outline-only, #hamburgermenu li:focus svg.outline-only{
    stroke: var(--accent);
    fill: transparent;
}

.remainder{
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding:15px;
    margin-top:10px;
    font-size: 12px;
    margin-top:auto;
    margin-bottom:70px;
}
.pblogo{
    display: flex;
    justify-content: center;
}

</style>